import Vue from 'vue';
import VueGtm from '@gtm-support/vue2-gtm';
import VueGtag from 'vue-gtag';
// import { addClarityScript } from '@/features/common/plugins/clarity';
import vuetify from './features/common/plugins/vuetify';
import router from './router';
import i18n from './i18n';
import store from './features/common/store';
import App from './App.vue';
import './features/common/directives';
import './features/common/globalComponents';
import './styles/main.scss';
// eslint-disable-next-line import/no-extraneous-dependencies
import 'flag-icons/css/flag-icons.min.css';
import './features/feedback-tool/plugins/userback';
import { getDomain } from './features/common/helpers';
import { GrowthBookVuePlugin } from './features/common/plugins/growthbook';

Vue.config.productionTip = false;

// setup google analytics
// const isLiveMode = process.env.VUE_APP_SERVER_MODE === 'live';
// const isTestMode = process.env.VUE_APP_SERVER_MODE === 'test';
const isProduction = process.env.NODE_ENV === 'production';
const subdomain = getDomain();

Vue.use(VueGtm, {
  id: subdomain === 'test' ? process.env.VUE_APP_GTM_ID_TEST : process.env.VUE_APP_GTM_ID,
  enabled: isProduction,
  loadScript: isProduction,
  vueRouter: router,
});

Vue.use(VueGtag, {
  config: { id: process.env.VUE_APP_GA_MEASUREMENT_ID },
});

// Clarity is now handled through GTM, so manual script addition is disabled
// if (isLiveMode || isTestMode) {
//   addClarityScript();
// }

Vue.use(GrowthBookVuePlugin, {
  featuresEndpoint: process.env.VUE_APP_GROWTHBOOK_FULL_API_ENDPOINT,
  enableDevMode: process.env.VUE_APP_GROWTHBOOK_IS_ENABLE_DEV_MODE === 'true',
});

new Vue({
  vuetify,
  router,
  i18n,
  store,
  render: (h) => h(App),
}).$mount('#app');
